<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="zoomStatus"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card :loading="loading">
      <!-- Full screen -->
      <v-toolbar
        v-if="zoomStatus"
        dark
        color="primary"
      >
        <v-btn
          icon
          @click="zoom()"
        >
          <v-icon>mdi-arrow-collapse</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span v-if="item.id">Cập nhật dữ liệu</span>
          <span v-else>Thêm mới</span>
        </v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <v-btn
            text
            @click="close"
          >
            Hủy bỏ
          </v-btn>
          <v-btn
            text
            color="yellow"
            @click="save(item)"
          >
            Lưu lại
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- Default screen -->
      <v-card-title v-if="!zoomStatus">
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              @click="zoom()"
            >
              <v-icon>mdi-arrow-expand</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-hover v-slot="{ hover }">
                <v-img
                  v-if="anh_dai_dien_url"
                  :src="anh_dai_dien_url"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
                <v-img
                  v-else
                  src="@/assets/NoImage.jpg"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
              </v-hover>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.tieu_de"
                label="Tiêu đề"
                class="require"
                hide-details
                autofocus
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="typeSelected"
                :items="types"
                item-text="dien_giai"
                item-value="id"
                label="Loại"
                class="require"
                hide-details
                return-object
                append-outer-icon="mdi-plus"
                @click:append-outer="showDialogType"
              />
              <FormType 
                :showDialog="dialogType" 
                :item="itemType" 
                @confirmed="onConfirmed" 
                @cancelled="onCancelled"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="levelSelected"
                :items="levels"
                item-text="text"
                item-value="value"
                label="Mức độ"
                hide-details
                return-object
              />
            </v-col>
            <v-col cols="12">
              <label>Mô tả</label>
              <quill-editor 
                v-model="item.mo_ta"
                :options="editorOption"
                style="min-height: 110px;"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <label class="require">Nội dung</label>
              <quill-editor 
                v-model="item.noi_dung"
                :options="editorOption"
                style="min-height: 150px;"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <v-file-input
                :disabled="existAttachFile"
                v-model="attachFile"
                accept="pdf"
                label="Văn bản kèm theo (pdf)"
                hide-details
              />
              <v-chip
                v-if="existAttachFile"
                class="ma-2"
                color="green"
                text-color="white"
                @click="getFile(item.attach_file)"
                close 
                @click:close="existAttachFile = false"
              >
                {{item.attach_file}}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="statusSelected"
                :items="status"
                item-text="text"
                item-value="value"
                label="Tình trạng"
                class="require"
                hide-details
                return-object
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="item.for_stat"
                label="Thống kê sâu bệnh, dịch bệnh"
                color="pink"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!zoomStatus">
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapActions, mapState } from 'vuex';
  import FormType from '@/views/admin/news/type/Form';
  export default {
    components: { 
      vueDropzone: vue2Dropzone,
      FormType
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        zoomStatus: false,
        dialog: false,
        dialogType: false,
        anh_dai_dien_url: null,
        errors_exist: false,
        errors: [],
        types: [],
        typeSelected: null,
        status: [
          {value: '0', text: 'Bí mật'},
          {value: '1', text: 'Công khai'}
        ],
        levels: [
          {value: 'DANGER', text: 'Khẩn cấp'},
          {value: 'WARNING', text: 'Cảnh báo'},
          {value: 'NORMAL', text: 'Bình thường'},
          {value: 'PREDICT', text: 'Dự báo'}
        ],
        statusSelected: null,
        levelSelected: null,
        attachFile: null,
        existAttachFile: false,
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
        itemType: {},
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
      this.getTypes();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.anh_dai_dien_url = null;
          if(this.item.anh_dai_dien) {
            this.anh_dai_dien_url = `${this.config.beUrl}/uploads/${this.item.anh_dai_dien}`;
          }
          this.typeSelected = this.types.find(
            element => element.id == this.item.danh_muc_id
          );
          this.statusSelected = this.status.find(
            element => element.value == (this.item.trang_thai || '1')
          );
          this.levelSelected = this.levels.find(
            element => element.value == (this.item.muc_do || 'NORMAL')
          );
          if(this.item.attach_file){
            this.existAttachFile = true;
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getTypes () {
        const app = this;
        axios.get("api/v1/news-categories")
          .then(response => {
            app.types = response.data;
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'warning',
              body: 'Chưa lấy được loại thông tin!'
            });
          });
      },
      zoom(){
        this.zoomStatus=!this.zoomStatus;
      },
      close() {
        this.dialog = false;
        this.zoomStatus=false;
        this.existAttachFile=false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/news`;
        let data = item;
        const file = app.attachFile;
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };
        let formData = new FormData();

        if(app.typeSelected){
          data.danh_muc_id = app.typeSelected.id;
        }
        if(app.statusSelected){
          data.trang_thai = app.statusSelected.value;
        }
        if(app.levelSelected){
          data.muc_do = app.levelSelected.value;
        }
        
        formData.append('tieu_de', data.tieu_de ? data.tieu_de : '');
        formData.append('mo_ta', data.mo_ta ? data.mo_ta : '');
        formData.append('noi_dung', data.noi_dung ? data.noi_dung : '');
        formData.append('trang_thai', data.trang_thai ? data.trang_thai : '');
        formData.append('danh_muc_id', data.danh_muc_id ? data.danh_muc_id : '');
        formData.append('muc_do', data.muc_do ? data.muc_do : '');
        formData.append('for_stat',  data.for_stat ? data.for_stat : 0);
        formData.append('anh_dai_dien',  data.anh_dai_dien ? data.anh_dai_dien : '');
        if(file) {
          formData.append('file',  file);
        }

        if (data.id) {
          url = `api/v1/news/${data.id}`;
          formData.append("_method", "patch");
        }

        app.loading=true;

        axios[method](
          url, 
          formData, 
          config
        )
          .then(function (response) {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.zoomStatus=false;
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          })
          .catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        const file = event.target.files[0];
        app.anh_dai_dien_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.anh_dai_dien=response.data.filePath;
          })
          .catch(function (error) {
            app.anh_dai_dien_url = null;
            app.openSnackbar({ type: 'error' });
          });
      },
      getFile(file){
        window.open(
          `${this.config.beUrl}/uploads/attach-file/${file}`,
          '_blank'
        );
      },
      showDialogType(){
        this.itemType = {};
        this.dialogType = true;
      },
      onConfirmed(item) {
        this.dialogType = false;
        this.types.unshift(item);
        this.typeSelected = item;
      },
      onCancelled () {
        this.dialogType = false;
      },
    }
  }
</script>
<style>
  .avatar-icon-upload{
    position: absolute;
    background: gray;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    cursor: pointer;
  }
  .avatar-icon-upload .v-icon{
    font-size: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>